var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3954 5.47911L24.3372 5.61751L18.713 18.9223L13.7606 18.7081C12.5789 18.657 11.4372 18.8895 10.3903 19.3475L13.7945 11.08L13.8727 10.8821L14.0082 10.5659C14.0482 10.4468 14.0882 10.3278 14.1446 10.2296C16.6843 4.23976 19.3161 2.96455 24.3954 5.47911Z",
    fill: "#E7EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3752 5.24351L26.3127 5.38935L20.271 19.4102H14.3335C12.9168 19.4102 11.5627 19.7018 10.3335 20.2227L13.9793 11.5143L14.0627 11.306L14.2085 10.9727C14.2502 10.8477 14.2918 10.7227 14.3543 10.6185C17.0835 4.30601 20.1668 2.86851 26.3752 5.24351Z",
    stroke: "#081E54",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6038 19.8255C36.6663 19.5339 35.6663 19.4089 34.6663 19.4089H20.2705L26.3122 5.38802L26.3747 5.24219C26.6872 5.34635 26.9788 5.49219 27.2913 5.61719L31.8955 7.55469C34.458 8.61719 36.2497 9.72135 37.333 11.0547C37.5413 11.3047 37.708 11.5339 37.8538 11.8047C38.0413 12.0964 38.1872 12.388 38.2705 12.7005C38.3538 12.888 38.4163 13.0755 38.458 13.2422C39.0205 14.9922 38.6872 17.138 37.6038 19.8255Z",
    stroke: "#081E54",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8368 29.5807V33.6432C44.8368 34.0599 44.8159 34.4766 44.7951 34.8932C44.3993 42.1641 40.3368 45.8307 32.6284 45.8307H16.3784C15.8784 45.8307 15.3784 45.7891 14.8993 45.7266C8.27425 45.2891 4.73258 41.7474 4.29508 35.1224C4.23258 34.6432 4.19092 34.1432 4.19092 33.6432V29.5807C4.19092 25.3932 6.73258 21.7891 10.3576 20.2266C11.6076 19.7057 12.9409 19.4141 14.3576 19.4141H34.6909C35.7118 19.4141 36.7118 19.5599 37.6284 19.8307C41.7743 21.1016 44.8368 24.9766 44.8368 29.5807Z",
    stroke: "#081E54",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8229 32.9062V34.7188C27.8229 36.2545 26.3943 37.4955 24.6354 37.4955C22.8765 37.4955 21.439 36.2545 21.439 34.7188V32.9062C21.439 34.442 22.8676 35.5313 24.6354 35.5313C26.3943 35.5313 27.8229 34.433 27.8229 32.9062Z",
    stroke: "#1552E8",
    strokeWidth: 1.33929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8215 30.4553C27.8215 30.9018 27.6965 31.3125 27.4823 31.6696C26.9555 32.5357 25.8751 33.0803 24.6251 33.0803C23.3751 33.0803 22.2947 32.5268 21.7679 31.6696C21.5537 31.3125 21.4287 30.9018 21.4287 30.4553C21.4287 29.6875 21.7858 29 22.3573 28.5C22.9376 27.991 23.7322 27.6875 24.6162 27.6875C25.5001 27.6875 26.2948 28 26.8751 28.5C27.4644 28.991 27.8215 29.6875 27.8215 30.4553Z",
    stroke: "#1552E8",
    strokeWidth: 1.33929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8229 30.4565V32.9118C27.8229 34.4475 26.3943 35.5368 24.6354 35.5368C22.8765 35.5368 21.439 34.4386 21.439 32.9118V30.4565C21.439 28.9207 22.8676 27.6797 24.6354 27.6797C25.5193 27.6797 26.314 27.9922 26.8944 28.4922C27.4658 28.9922 27.8229 29.6886 27.8229 30.4565Z",
    stroke: "#1552E8",
    strokeWidth: 1.33929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.979 11.5156L10.3332 20.224C6.70817 21.7865 4.1665 25.3906 4.1665 29.5781V23.474C4.1665 17.5573 8.37484 12.6198 13.979 11.5156Z",
    stroke: "#081E54",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8304 23.474V29.5781C44.8304 24.9948 41.7887 21.099 37.6221 19.849C38.7054 17.1406 39.0179 15.0156 38.4971 13.2448C38.4554 13.0573 38.3929 12.8698 38.3096 12.7031C42.1846 14.7031 44.8304 18.8073 44.8304 23.474Z",
    stroke: "#081E54",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.964 42.856C16.964 43.4989 16.8837 44.1216 16.7229 44.7243C16.5421 45.5279 16.2207 46.3114 15.7989 46.9944C14.4127 49.3248 11.8613 50.8917 8.92829 50.8917C6.8591 50.8917 4.99079 50.1082 3.58454 48.8225C2.98186 48.3002 2.45952 47.6775 2.05773 46.9944C1.31443 45.7891 0.892578 44.3627 0.892578 42.856C0.892578 40.6864 1.75643 38.6976 3.16268 37.2512C4.6292 35.7445 6.67829 34.8203 8.92829 34.8203C11.2988 34.8203 13.4484 35.8449 14.8948 37.4922C16.1805 38.9186 16.964 40.8069 16.964 42.856Z",
    fill: "#A020FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9255 42.8281H5.93896",
    stroke: "white",
    strokeWidth: 1.33929,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93311 39.8828V45.8895",
    stroke: "white",
    strokeWidth: 1.33929,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12);
export default __webpack_public_path__ + "static/media/icon-12.42fc0da8ae611e45d0f1bd485c391a53.svg";
export { ForwardRef as ReactComponent };